import { Outlet } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';
import { useUIStore } from '@/stores/ui.store';
import { cn } from '@/lib/utils';

/**
 * Authenticated shell — Sidebar (fixed) + scrollable main area.
 * Page-level TopBanner is mounted per-route so each page controls
 * its title, search placeholder, etc.
 *
 * Mobile (<md): Sidebar becomes an off-canvas drawer. This shell renders
 * the dimming scrim behind it; the drawer itself lives in Sidebar.tsx.
 */
export function Layout() {
  const sidebarCollapsed = useUIStore((s) => s.sidebarCollapsed);
  const setSidebarCollapsed = useUIStore((s) => s.setSidebarCollapsed);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar />
      {/* Scrim: only relevant on mobile, dims content while the drawer is open */}
      <div
        className={cn(
          'fixed inset-0 z-30 bg-black/50 transition-opacity duration-300 ease-out md:hidden',
          sidebarCollapsed ? 'pointer-events-none opacity-0' : 'opacity-100',
        )}
        onClick={() => setSidebarCollapsed(true)}
        aria-hidden="true"
      />
      <main className="flex flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
